var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4454 4.19727H2.28831C1.24141 4.19727 0.391113 5.04756 0.391113 6.09446V22.1027C0.391113 23.1495 1.24141 23.9998 2.28831 23.9998H13.4454C14.4923 23.9998 15.3426 23.1495 15.3426 22.1027V6.09446C15.3377 5.04756 14.4874 4.19727 13.4454 4.19727ZM14.0106 22.0977C14.0106 22.4123 13.755 22.6679 13.4405 22.6679H2.28339C1.96883 22.6679 1.71325 22.4123 1.71325 22.0977V6.09446C1.71325 5.7799 1.96883 5.52432 2.28339 5.52432H13.4405C13.755 5.52432 14.0106 5.7799 14.0106 6.09446V22.0977Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7115 0H6.55442C5.50752 0 4.65723 0.850297 4.65723 1.89719C4.65723 2.26582 4.95213 2.56072 5.32075 2.56072C5.68938 2.56072 5.98428 2.26582 5.98428 1.89719C5.98428 1.58263 6.23986 1.32705 6.55442 1.32705H17.7115C18.0261 1.32705 18.2816 1.58263 18.2816 1.89719V17.9054C18.2816 18.2199 18.0261 18.4755 17.7115 18.4755C17.3429 18.4755 17.048 18.7704 17.048 19.1391C17.048 19.5077 17.3429 19.8026 17.7115 19.8026C18.7584 19.8026 19.6087 18.9523 19.6087 17.9054V1.89719C19.6087 0.850297 18.7584 0 17.7115 0Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/Copy Icon.072759ad496876299e8556d5723ce088.svg";
export { ForwardRef as ReactComponent };